import { render } from "./NodeReorder.vue?vue&type=template&id=a3e2cd58"
import script from "./NodeReorder.vue?vue&type=script&lang=js"
export * from "./NodeReorder.vue?vue&type=script&lang=js"
script.render = render

export default script